module.exports = __webpack_public_path__ + "static/media/02B.fb9fa12e.png";